import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import OrderColumn from "../../Global/OrderColumn";
import { FaSort } from "react-icons/fa";
import { ImageCard } from "../../Global/ImageCard";
import useStaffList from "./useStaffList";
import AddStaff from "./AddStaff";
import EmptyData from "../../Global/EmptyData";

const StaffList = () => {
  const {
    isLoading,
    isFetching,
    imageData,
    staffList,
    showEditModal,
    staffState,
    showImageModal,
    paginationOptions,
    handleEditColumnsClick,
    updateStaffFields,
    handleDeleteModal,
    handleCreateClick,
    handleEditAction,
    handleClearClick,
    handlePagination,
    closeImageModal,
    handlePageSize,
    handleSearch,
    handleDelete,
    handleSort,
    refetch,
    getRow,
  } = useStaffList();
  return (
    <div>
      <HeadingGroup
        title={"Staff"}
        className={`pro-mb-4`}
        buttonTitle={staffList?.data?.create_permission && "Create"}
        handleClick={handleCreateClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={staffState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: staffState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {staffList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={staffList?.data?.result || []}
            uniqueID={"_id"}
            fields={staffList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            handleSort={handleSort}
            getRow={getRow}
            clear={staffState.clearSelection}
            loading={isFetching}
            perpage={staffState?.currentPageSize}
            assignable={false}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteModal}
            deletable={staffList?.data?.delete_permission}
            editable={staffList?.data?.edit_permission}
            showCheckBox={
              staffList?.data?.delete_permission ||
              staffList?.data?.edit_permission
            }
          />
        )}

        {staffList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={staffState?.currentPage}
            totalPageCount={Math.ceil(
              staffList?.data?.total_count / staffState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === staffState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={staffState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure delete the selected Staff ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={staffList?.data?.fields || []}
              moduleId={staffList?.data?.module_id}
              updateData={updateStaffFields}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={staffState?.showCreateModal}
          handleClose={handleCreateClick}
          title={staffState?.isEdit ? "Update Staff" : "Add Staff"}
          backdrop={"static"}
        >
          <AddStaff
            refetch={refetch}
            handleCreateClick={handleCreateClick}
            isStickyFooter
            staffState={staffState}
          />
        </OffCanvasLayout>
        <ModalLayout
          show={showImageModal}
          handleClose={closeImageModal}
          backdrop="static"
        >
          <ImageCard data={imageData} handleClose={closeImageModal} />
        </ModalLayout>
      </div>
    </div>
  );
};

export default StaffList;
